import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const user = await login(email, password);
      if (user.role === 'serveur') navigate('/serveur');
      else if (user.role === 'cuisine') navigate('/cuisine');
      else if (user.role === 'caisse' || user.role === 'admin') navigate('/caisse');
    } catch (err) {
      setError('Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800">VAH'INN</h1>
          <p className="text-gray-500 mt-2">Système de commande</p>
        </div>

        {/* Erreur */}
        {error && (
          <div className="bg-red-100 text-red-700 p-3 rounded-lg mb-4 text-center">
            {error}
          </div>
        )}

        {/* Formulaire */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-1">Email</label>
            <input
  type="email"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  className="w-full border border-gray-300 rounded-lg px-4 py-3 text-lg focus:outline-none focus:border-blue-500"
  placeholder="votre@email.mg"
  autoComplete="off"
  required
/>
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">Mot de passe</label>
           <input
  type="password"
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  className="w-full border border-gray-300 rounded-lg px-4 py-3 text-lg focus:outline-none focus:border-blue-500"
  placeholder="••••••••"
  autoComplete="new-password"
  required
/>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-3 rounded-lg text-lg font-semibold hover:bg-blue-700 transition disabled:opacity-50"
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        {/* Comptes rapides pour test */}
        <div className="mt-6 border-t pt-4">
          <p className="text-gray-500 text-sm text-center mb-3">Connexion rapide (test)</p>
          <div className="grid grid-cols-2 gap-2">
            {[
             { label: 'Serveur 1', email: 'serveur1@vahinn.mg' },
{ label: 'Serveuse 2', email: 'serveuse2@vahinn.mg' },
{ label: 'Serveuse 3', email: 'serveuse3@vahinn.mg' },
{ label: 'Cuisine', email: 'cuisine@vahinn.mg' },
{ label: 'Caisse', email: 'caisse@vahinn.mg' },
{ label: 'Admin', email: 'admin@vahinn.mg' },
            ].map((compte) => (
              <button
                key={compte.email}
onClick={() => { setEmail(compte.email); setPassword(''); }}                className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-3 rounded-lg transition"
              >
                {compte.label}
              </button>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}